import { FiBookOpen, FiFolder, FiGrid, FiTruck, FiUsers } from "react-icons/fi";
import { PERMISSIONS } from "../constants/permissions";
import { hasPermission } from "../utils/permissions";

const dashboardItem = {
  label: "Dashboard",
  icon: FiGrid,
  to: "/",
};

const accessGroup = {
  label: "Access",
  icon: FiUsers,
  children: [
    { label: "Users", to: "/access/users", permission: PERMISSIONS.USER_READ },
    { label: "Roles", to: "/access/roles", permission: PERMISSIONS.ROLE_READ },
  ],
};

const projectsItem = {
  label: "Projects",
  icon: FiFolder,
  to: "/projects",
  permission: PERMISSIONS.PROJECT_READ,
};

const vendorsItem = {
  label: "Vendors",
  icon: FiTruck,
  to: "/vendors",
  permission: PERMISSIONS.VENDOR_READ,
};

const expensesItem = {
  label: "Expenses",
  icon: FiBookOpen,
  to: "/expenses",
  permission: PERMISSIONS.EXPENSE_READ,
};

const allMenuItems = [dashboardItem, accessGroup, projectsItem, vendorsItem, expensesItem];

function canSeeMenuItem(user, item) {
  if (!item.permission) return true;
  return hasPermission(user, item.permission);
}

/** Sidebar items filtered by the logged-in user's permissions. */
export function getSidebarMenuForUser(user) {
  return allMenuItems
    .map((item) => {
      if (item.children) {
        const children = item.children.filter((child) => canSeeMenuItem(user, child));
        if (children.length === 0) return null;
        return { ...item, children };
      }
      if (!canSeeMenuItem(user, item)) return null;
      return item;
    })
    .filter(Boolean);
}

/** @deprecated Use getSidebarMenuForUser */
export function getSidebarMenu(isSuperAdminUser) {
  if (isSuperAdminUser) return allMenuItems;
  return [dashboardItem, projectsItem, vendorsItem, expensesItem];
}

export const sidebarMenuFull = allMenuItems;
export const sidebarMenuProjectsOnly = [dashboardItem, projectsItem, vendorsItem, expensesItem];
